import React from 'react';
import styled from 'styled-components';


const TextBoxBlock = styled.p`
    display: ${props=>props.display ||"-webkit-box"};
    height: ${props => props.height || '48px'};
    line-height: ${props=>props.lineHeight ||"1.5"};;
    color: #333;
    font-size: ${props => props.fontSize || '16px'};
    font-weight: ${props => props.fontWeight || '300'};
    word-wrap: break-word;
    -webkit-line-clamp:  ${props => props.lineClamp || '2'};
    -webkit-box-orient: vertical;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    margin-top: ${props => props.marginTop || '0px'};
    margin-bottom: ${props => props.marginBottom || '0px'};
    margin-left:${props => props.marginLeft || '0px'};
    margin-right:${props => props.marginRight || '0px'};
    cursor: ${props => props.cursor || "pointer"};
    white-space: ${props => props.whiteSpace || "normal"};
    flex: ${props=>props.flex || "0"};
`;

const TextBox = (props) => {
    return (
        <TextBoxBlock {...props}>
            {props.text}
        </TextBoxBlock>
    );
};

TextBox.defaultProps = {cursor:"pointer"};

export default TextBox;
